
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import NSelect from '@/uikit/select/NSelect.vue';
import { ISelectItem } from '@/uikit';
import { viewModelRepository } from '@/api/common';

@Options({
  name: 'UserSelect',
  components: { NSelect }
})
export default class UserSelect extends Vue {
  // todo: fix this component; init value don't work on page load
  @Prop({ type: Number, required: true })
  readonly modelValue!: number;

  @Prop({ type: String })
  readonly prefixIcon?: string;

  get module() {
    return viewModelRepository.getUsersListViewModel();
  }

  async loadItems(value: number[]): Promise<ISelectItem[]> {
    this.module.filter.current.real_name_contains = '';
    this.module.filter.current.id_in = value;
    await this.module.get();
    return this.module.items.map((item) => {
      return {
        value: item.id,
        label: item.real_name
      };
    });
  }

  async searchItems(value: string): Promise<ISelectItem[]> {
    this.module.filter.current.id_in = [];
    this.module.filter.current.real_name_contains = value;
    await this.module.get();
    return this.module.items.map((item) => {
      return {
        value: item.id,
        label: item.real_name
      };
    });
  }

  updateValue(value: number) {
    this.$emit('update:modelValue', value);
  }
}
